import React from 'react'
import { withRouter } from "react-router-dom";
import TableComponent, { TableOp } from '../../components/table/TableOps';
import { AuthContext } from "../../context/authContext";
import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import EADLog from './EADLog';
import ACCESS from '../../ACCESS';

const EAD_MODALS = {
   LOG: 100
}

class EADToday extends TableComponent {

   componentDidMount() {
      let acciones = [
         { id: 'edit', icon: 'edit', tooltip: 'Editar', access: [ACCESS.CITAS_EAD.EDITAR_CITAS_CLIENTE, ACCESS.CITAS_EAD.EDITAR_CITAS_SUCURSAL, ACCESS.CITAS_EAD.EDITAR_CITAS_TODAS, ACCESS.CITAS_EAD.EDITAR_CITAS_USUARIO] },
      ];

      this.tableConfig(
         { dataUrl: 'ead/today', deleteUrl: '', deleteField: '', modUrl: '/EAD/Edit', key: 'folio_ead' },
         TableOp.Table('Citas del Dia', [
            { label: 'Folio Cita', id: 'folio_ead' },
            { label: 'Fecha Cita', id: 'fecha_ead' },
            { label: 'Estatus Cita', id: 'status_ead' },
            { label: 'Detalle', id: 'concepto' },
            { label: 'Guia', id: 'g_folio' },
            { label: 'Cliente', id: 'cliente' },
            { label: 'Estatus de la Guia', id: 'status_guia' },

         ], acciones))
      this.table();
   }

   action = (id, row, cb) => {
      if (id === 'edit') {
         this.props.history.push(`${this.config.modUrl}/${row.id}`)
      } else if (id === 'log') {
         this.setState({ selectedRow: row, modal: EAD_MODALS.LOG });
      }
   }

   render() {
      const { modal = null, selectedRow } = this.state;
      const { hasAccess } = this.context;
      return (
         <div style={{ margin: 10 }} >

            <div style={{
               display: 'flex',
               width: '100%',
               justifyContent: 'flex-end',
               padding: 5,
            }} >
               <Button
                  variant='contained'
                  onClick={() => { this.props.history.push(`/EAD/Edit/Create`); }}
                  color='primary'>
                  {`Nueva Cita`}
               </Button>
            </div>
            <this.TableRender />

            {/** Modal de historial EAD */}
            <Dialog
               maxWidth='md'
               open={modal === EAD_MODALS.LOG}
               onClose={() => this.setState({ modal: null })}
            >
               <DialogContent>
                  {selectedRow && (<EADLog id={selectedRow.id} />)}
               </DialogContent>
               <DialogActions>
                  <Button onClick={() => this.setState({ modal: null })} color="primary">
                     Cerrar
                  </Button>
               </DialogActions>
            </Dialog>
         </div>
      )
   }
}

EADToday.contextType = AuthContext;
export default withRouter(EADToday)